import React from 'react';
import { translate } from 'react-i18next';
import { Text, View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import Theme from '../../theme';

import arrowDown from '../../assets/images/arrow-down.png';
import arrowUp from '../../assets/images/arrow-up.png';
import {
    BookIcon,
} from '../../ui/components/Icons';
import { defaultScale } from '../../utils/scaling';

const Arrow = ({ order }) =>
    <Image
        style={{
            width: defaultScale(10),
            height: defaultScale(13)
        }}
        source={order == 'down' ? arrowDown : arrowUp}
    />


const StatsHistoryHeader = ({
    sortByDate,
    sortByBodyWeight,
    sortByMuscleMass,
    sortByBodyFat,
    field,
    order,
}) => (
        <View style={styles.container}>
            <View style={styles.cell}>
                <TouchableOpacity
                    onPress={sortByDate}
                    style={styles.buttonContainer}>
                    <BookIcon color={field == 'date' ? Theme.PRIMARY : Theme.BLACK} width={defaultScale(25)} height={defaultScale(25)} />
                    {field == 'date' &&
                        <Arrow order={order} />
                    }
                </TouchableOpacity>
            </View>
            <View style={styles.cell}>
                <TouchableOpacity
                    onPress={sortByBodyWeight}
                    style={styles.buttonContainer}>
                    <Text style={[styles.headerText, field == 'bodyWeight' && styles.activeField]}>
                        Body{"\n"}
                        Weight
                    </Text>
                    {field == 'bodyWeight' &&
                        <Arrow order={order} />
                    }
                </TouchableOpacity>
            </View>
            <View style={styles.cell}>
                <TouchableOpacity
                    onPress={sortByMuscleMass}
                    style={styles.buttonContainer}>
                    <Text style={[styles.headerText, field == 'muscleMass' && styles.activeField]}>
                        Muscle{"\n"}
                        Mass
                    </Text>
                    {field == 'muscleMass' &&
                        <Arrow order={order} />
                    }
                </TouchableOpacity>
            </View>
            <View style={styles.cell}>
                <TouchableOpacity
                    onPress={sortByBodyFat}
                    style={styles.buttonContainer}>
                    <Text style={[styles.headerText, field == 'bodyFat' && styles.activeField]}>
                        Body{"\n"}
                        Fat %
                    </Text>
                    {field == 'bodyFat' &&
                        <Arrow order={order} />
                    }
                </TouchableOpacity>
            </View>
        </View>
    );

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: Theme.GREY_LIGHT,
        justifyContent: 'space-between',
        marginHorizontal: defaultScale(10),
    },
    cell: {
        flex: 1,
        flexBasis: 0,
        paddingVertical: defaultScale(10),
        borderRightWidth: 0,
        alignItems: 'center',
        justifyContent: 'center',
        borderRightColor: Theme.GREY_DARK_MEDIUM,
    },
    noBorder: {
        borderRightWidth: 0,
    },
    buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerText: {
        ...Theme.textStyle.small,
        color: Theme.GREY_DARK,
        fontFamily: Theme.CustomBold,
        textAlign: "left"
    },
    activeField: {
        color: Theme.PRIMARY,
    }
});

export default StatsHistoryHeader;
